import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramComponent } from './program.component';
import { AddProgramComponent } from './add-program/add-program.component';
import { EditProgramComponent } from './edit-program/edit-program.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ConfigurareProgramComponent } from './configurare-program/configurare-program.component';
import { ConfigurareSloturiComponent } from './configurare-sloturi/configurare-sloturi.component';
import { SloturiBlocareComponent } from './sloturi-blocare/sloturi-blocare.component';
import { AddSloturiBlocareComponent } from './sloturi-blocare/add-sloturi-blocare/add-sloturi-blocare.component';
import { EditSloturiBlocareComponent } from './sloturi-blocare/edit-sloturi-blocare/edit-sloturi-blocare.component';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';


@NgModule({
    declarations: [
        ProgramComponent,
        AddProgramComponent,
        EditProgramComponent,
        ConfigurareProgramComponent,
        ConfigurareSloturiComponent,
        SloturiBlocareComponent,
        AddSloturiBlocareComponent,
        EditSloturiBlocareComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxMatTimepickerModule
    ],
    exports: [ProgramComponent]
})
export class ProgramModule { }
